import { NgModule } from '@angular/core';
import { RouterModule, Route } from '@angular/router';
import { AuthGuard } from '@core/guards/auth.guard';
import { MfaComponent } from '@modules/auth/components/mfa/mfa-settings.component';
import { AppInitializationWithUriPage } from '@pages/auth/app-initialization-with-uri.page';

import { AppInitializationPage } from '@pages/auth/app-initialization.page';
import { LoginPage } from '@pages/auth/login.page';
import { SetPasswordComponent } from '@pages/auth/set-password/set-password.component';
import { LinkExpireComponent } from '@pages/error/link-expire/link-expire.component';

const routes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login'
  },
  {
    path: 'login',
    title: 'Entire OnHire - Client Portal',
    component: LoginPage
  },
  {
    path: 'setpassword',
    title: 'Entire OnHire - Set Password',
    component: SetPasswordComponent
  },
  {
    path: 'app-initialization',
    title: 'Entire OnHire - Client Portal',
    component: AppInitializationPage
  },
  {
    path: 'uri',
    title: 'Entire OnHire - Client Portal',
    component: AppInitializationWithUriPage
  },
  {
    path: 'linkExpire',
    title: 'Entire OnHire - Link Expire',
    component: LinkExpireComponent
  },
  { 
    path: 'mfa', 
    title: 'Entire OnHire - Client Portal',
    component: MfaComponent 
  },
  {
    path: 'client',
    canLoad: [AuthGuard],
    loadChildren: () => import('@core/core.module').then(module => module.CoreModule)
  },
  {
    path: 'professional',
    canLoad: [AuthGuard],
    loadChildren: () => import('@core/core.module').then(module => module.CoreModule)
  },
  {
    path: 'error',
    loadChildren: () => import('@modules/error/error.module').then(module => module.ErrorModule)
  },
  {
    path: '**',
    redirectTo: 'error/404'
  }
]

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }